/**
 * Default Theme Options
 * Used to prevent errors if there is
 * no data from WordPress backend
 */

if (typeof window.theme === 'undefined') {
	window.theme = {
		colors: {
			accentPrimary: '#b68c70',
			accentSecondary: '#9b724d'
		},
		typography: {
			fontPrimary: 'Poppins',
			fontSecondary: 'Playfair Display'
		}
	}
}

/**
 * ScrollMagic Setup
 */
window.SMController = new ScrollMagic.Controller();
window.SMController.enabled(false);
window.SMSceneTriggerHook = 0.85;
window.SMSceneReverse = false;

/**
 * Theme Fonts
 */
window.fontPrimaryObserver = new FontFaceObserver(window.theme.typography.fontPrimary).load();

/**
 * Theme Colors
 * Handle theme colors in IE11
 * that doesn't support css variables
 */

if (!Modernizr.customproperties && typeof cssVars === 'function') {

	cssVars();

}

/**
 * Load common components
 */
$(document).ready(function () {
	new Social();
	new Form();
	new Burger();
	new Button();
	new Menu();
	objectFitImages();
	fixMobileBarHeight();
});

/**
 * Enable on-scroll animations
 * once preloader animation is complete
 */
Preloader().then(function () {

	setTimeout(function () {
		window.SMController.enabled(true);
		window.SMController.update(true);
	}, 200);

});
